import React, { useEffect, useState } from "react";
import '../../assets/css/Cart.css';
import toast, { Toaster } from 'react-hot-toast';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function CartList() {
  const notify = () => toast.success('Successfully Added to Cart');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="TableBoxcart">
      <Toaster position="top-right" reverseOrder={false} />
      <div className="table-responsive">
        <div className="table-box-content">
          <div className="table-header-fixed">
            <table className="table table-sm table-striped mb-0">
              <thead className="text-center">
                <tr>
                  {isLoading ? (
                    <td colSpan={8}><Skeleton height={30} /></td>
                  ) : (
                    <>
                      <th className="table-header">Size</th>
                      <th className="table-header">Barcode</th>
                      <th className="table-header">Shape</th>
                      <th className="table-header">Stock</th>
                      <th className="table-header">Ord. Qty</th>
                      <th className="table-header">MRP (<i className="bi bi-currency-rupee"></i>)</th>
                      <th className="table-header">Cart</th>
                      <th className="table-header">Wishlist</th>
                    </>
                  )}
                </tr>
              </thead>
            </table>
          </div>

          <div className="table-body-scroll">
            <table className="table table-sm table-striped mb-0">
              <tbody>
                {isLoading ? (
                  <tr>
                    {[...Array(8)].map((_, index) => (
                      <td key={index}><Skeleton height={30} /></td>
                    ))}
                  </tr>
                ) : (
                  [...Array(5)].map((_, idx) => (
                    <tr key={idx}>
                      <td className="align-middle">60X150</td>
                      <td className="align-middle">8907831253440</td>
                      <td className="align-middle">Rectangle</td>
                      <td className="align-middle text-center">53</td>
                      <td className="align-middle text-center">
                        <select className="form-control form-control-sm select-List">
                          {[...Array(11).keys()].map(i => (
                            <option value={i} key={i}>{i}</option>
                          ))}
                          <option value="10+">10+</option>
                        </select>
                      </td>
                      <td className="align-middle">3900.00</td>
                      <td className="align-middle text-center">
                        <div className="customer-selected-cart">
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary addtocart"
                            onClick={notify}
                            title="Add to Cart"
                          >
                            <i className="fa fa-spinner fa-spin d-none" id={`spinner_${idx}`} />
                            <i className="bi bi-cart-plus" />
                          </button>
                        </div>
                      </td>
                      <td className="align-middle text-center">
                        <button type="button" className="btn btn-outline-secondary WishListbtn" title="Add to Wishlist">
                          <i className="bi bi-heart" />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CartList;
